<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Configurações</p>
        </div>

        <div class="muven-content">
            <div class="muven-card muven-card-md muven-card-centered mb-3">
                <div class="muven-card-title">
                    <p>Sincronização Muven x Canais</p>
                </div>

                <div>
                    <p>Caso queira forçar a sincronização das informações encontradas no Muven com as informações em seus canais, basta clicar no botão "Forçar sincronização".</p>
                </div>

                <div class="muven-card-actions">
                    <button class="btn btn-outline-primary" 
                    :disabled="syncingChannels"
                    @click="syncChannels()">
                        Forçar sincronização

                        <Loading v-show="syncingChannels" />
                    </button>
                </div>
            </div>
            
            <div class="muven-card muven-card-md muven-card-centered mb-3">
                <div class="muven-card-title">
                    <p>Cache</p>
                </div>

                <div>
                    <p>Caso queira limpar as informações que estão em cache de <b>{{subscriber.name}}</b>, basta clicar no botão "Limpar cache".</p>
                </div>

                <div class="muven-card-actions">
                    <button class="btn btn-outline-primary" 
                    :disabled="clearingCache"
                    @click="clearCache()">
                        Limpar cache

                        <Loading v-show="clearingCache" />
                    </button>
                </div>
            </div>

            <div class="muven-card muven-card-md muven-card-centered mb-3" v-if="!userAuthenticated.isImpersonate()">
                <div class="muven-card-title">
                    <p>Usuários</p>
                </div>

                <div>
                    <p>Gerencie os usuários e suas respectivas funções com acesso a empresa <b>{{subscriber.name}}</b>.</p>
                </div>

                <div class="muven-card-actions">
                    <button class="btn btn-outline-primary" 
                        @click="goToMemberManagement()">
                        <span>Gerenciar</span>
                    </button>
                </div>
            </div>

            <div class="muven-card muven-card-md muven-card-centered mb-3" v-if="!subscriber.isBackendInterfacenet()">
                <div class="muven-card-loading" v-show="loadingCredentials">
                    <div class="muven-card-loading-message-container">
                        <p class="loading-message">
                            <fa class="loading-icon" icon="sync-alt" spin />
                        </p>
                    </div>
                </div>

                <div class="muven-card-title">
                    <p>Integração retaguarda</p>
                </div>

                <div>
                    <div v-show="subscriber.isBackendBimer()">
                        <div class="form-group copiable-content">
                            <label>Client ID</label>
                            <input type="text" 
                                class="form-control"
                                disabled
                                v-model="backendCredentials.clientId" />
                            <fa :icon='["far", "copy"]' class="icon-copy" :data-clipboard-text="backendCredentials.clientId"/>
                        </div>

                        <div class="form-group copiable-content">
                            <label>Client Secret</label>
                            <input type="text" 
                                class="form-control"
                                disabled
                                v-model="backendCredentials.clientSecret" />
                            <fa :icon='["far", "copy"]' class="icon-copy" :data-clipboard-text="backendCredentials.clientSecret"/>
                        </div>
                    </div>

                    <div class="form-group copiable-content">
                        <label>Chave</label>
                        <input type="text"
                            class="form-control"
                            v-model="backendCredentials.key" 
                            disabled />
                        <fa :icon='["far", "copy"]' class="icon-copy" :data-clipboard-text="backendCredentials.key"/>
                    </div>

                    <div class="form-group copiable-content">
                        <label>Senha</label>
                        <input type="text" 
                            class="form-control"
                            v-model="backendCredentials.password" 
                            disabled />
                        <fa :icon='["far", "copy"]' class="icon-copy" :data-clipboard-text="backendCredentials.password"/>
                    </div>
                </div>
            </div>

            <div class="muven-card muven-card-md muven-card-centered mb-3" v-if="subscriber.isBackendInterfacenet()">
                <div class="muven-card-loading" v-show="loadingCredentials || loadingInterfacenetCredentials">
                    <div class="muven-card-loading-message-container">
                        <p class="loading-message">
                            <fa class="loading-icon" icon="sync-alt" spin />
                        </p>
                    </div>
                </div>

                <div class="muven-card-title">
                    <p>
                        <span>Integração retaguarda</span>

                        <span class="float-right">
                            <SwitchToggle 
                                :prop-check="backendCredentials.isActive"
                                :label-checked="''"
                                :label-unchecked="''"
                                @updated="interfacenetActivationHandler"
                            />
                        </span>
                    </p>
                    <p class="muven-card-subtitle">
                        <span v-show="backendCredentials.isActive">Integração ATIVA</span>
                        <span v-show="!backendCredentials.isActive">Integração INATIVA</span>
                    </p>
                </div>

                <div>
                    <div class="row">
                        <div class="col-12">
                            <div class="muven-tip muven-tip-standalone tip-danger mb-3" v-show="hasErrorInterfacenetCredentials">
                                <fa icon="info" class="tip-icon" />
                                <p>Houve um problema no carregamento das informações, por isso não será possível salvar as alterações. Verifique o erro e tente novamente mais tarde.</p>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col">
                            <label>Client ID</label>
                            <input type="text"
                                class="form-control"
                                v-model="backendCredentials.clientId" />
                        </div>

                        <div class="form-group col">
                            <label>Client Secret</label>
                            <input type="text" 
                                class="form-control"
                                v-model="backendCredentials.clientSecret" />
                        </div>

                        <div class="col-1 text-right mr-3">
                            <label class="invisible-label">.</label>
                            <button class="btn btn-outline-secondary"
                                :disabled="loadingInterfacenetCredentials"
                                @click="retrieveAllInterfacenetListsBasedOnClientIdAndClientSecret(backendCredentials)">
                                <fa icon="sync-alt" />
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col">
                            <label>Client Name</label>
                            <input type="text" 
                                class="form-control"
                                v-model="backendCredentials.clientName" />
                        </div>

                        <div class="form-group col">
                            <label>Código da rede</label>
                            <multiselect
                                v-model="backendCredentials.redeStock"
                                :options="interfacenetStoreListOptions"
                                :multiple="false"
                                :show-labels="false"
                                :allow-empty="false"
                                @select="retrieveAllInterfacenetListsBasedOnAllInfo"
                                label="value"
                                track-by="key"
                                placeholder="" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col">
                            <label>Tabela de preço</label>
                            <multiselect
                                v-model="backendCredentials.priceTable"
                                :options="interfacenetPriceTableListOptions"
                                :multiple="false"
                                :show-labels="false"
                                label="value"
                                track-by="key"
                                placeholder="" />
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Lojas responsáveis pelo estoque</label>
                        <multiselect
                            v-model="backendCredentials.filialStock"
                            :options="interfacenetBranchListOptions"
                            :multiple="true"
                            :show-labels="false"
                            label="value"
                            track-by="key"
                            placeholder="" />
                    </div>

                    <div class="form-group">
                        <label>Loja responsável pela baixa dos pedidos</label>
                        <multiselect
                            v-model="backendCredentials.filialSales"
                            :options="interfacenetBranchListOptions"
                            :multiple="false"
                            :show-labels="false"
                            label="value"
                            track-by="key"
                            placeholder="" />
                    </div>

                    <div class="row">
                        <div class="form-group col">
                            <label>Tipo produto master</label>
                            <multiselect
                                v-model="backendCredentials.tipoProdutoMasterWrapper"
                                :options="interfacenetTypeProductListOptions"
                                :multiple="false"
                                :show-labels="false"
                                :disabled="alreadyHasProducts"
                                label="description"
                                track-by="enum"
                                placeholder="" />
                        </div>

                        <div class="form-group col">
                            <label>Código Vendedor padrão</label>
                            <input type="text" 
                                class="form-control"
                                v-model="backendCredentials.codigoVendedorPadrao" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col">
                            <label>Peso padrão (em kilos)</label>
                            <input type="number"
                                step="0.1"
                                class="form-control"
                                v-model="backendCredentials.defaultWeight" />
                        </div>

                        <div class="form-group col">
                            <label>Altura padrão (em cm)</label>
                            <input type="number"
                                step="1"
                                class="form-control"
                                v-model="backendCredentials.defaultHeight" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col">
                            <label>Largura padrão (em cm)</label>
                            <input type="number"
                                step="1"
                                class="form-control"
                                v-model="backendCredentials.defaultWidth" />
                        </div>

                        <div class="form-group col">
                            <label>Profundidade padrão (em cm)</label>
                            <input type="number"
                                step="1"
                                class="form-control"
                                v-model="backendCredentials.defaultDepth" />
                        </div>
                    </div>
                </div>

                <div class="muven-card-actions">
                    <button class="btn btn-outline-primary" 
                        :disabled="hasErrorInterfacenetCredentials"
                        @click="submitInterfaceNetCredentials(backendCredentials)">
                        Gravar

                        <Loading v-show="loadingInterfacenetCredentials" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import subscriberService from '@/subscriber/services/SubscriberService'
import { SubscriberBackendCredentialsFactory } from '../../subscriber/factories/SubscriberBackendCredentialsFactory'
import ClipboardJS from "clipboard";
import { SubscriberBackendInterfacenetCredentialsModel } from '../../subscriber/models/SubscriberBackendInterfacenetCredentialsModel';
import ProductService from '../../product/services/ProductService';

export default {
    name: 'SettingsView',    
    data() {
        return {
            clearingCache: false,
            loadingCredentials: false,
            loadingInterfacenetCredentials: false,
            syncingChannels: false,
            alreadyHasProducts: false,
            backendCredentials: {},
            interfacenetBranchListOptions: [],
            interfacenetStoreListOptions: [],
            interfacenetPriceTableListOptions: [],
            interfacenetTypeProductListOptions: SubscriberBackendInterfacenetCredentialsModel.getTypeProductMasterList(),
            hasErrorInterfacenetCredentials: false,
            clipboard: new ClipboardJS('.form-group.copiable-content .icon-copy'),
        }
    },
    methods: {
        async syncChannels() {
            this.syncingChannels = true

            try {
                await subscriberService.forceChannelSync()
                this.$floatingAlert.info({
                    message: 'O pedido de sincronização foi adicionado à fila.',  
                    timeVisible: 10000,
                })
            } catch (e) {
                this.$floatingAlert.error({
                    title: 'Oops!',
                    message: e.message || 'Houve um problema no momento de iniciar a sincronização. Tente novamente mais tarde',
                })
            }

            this.syncingChannels = false
        },
        async clearCache() {
            this.clearingCache = true

            try {
                await subscriberService.clearCache()
                this.$floatingAlert.success({
                    message: 'O cache foi limpo com sucesso!',  
                    timeVisible: 10000,
                })
            } catch (e) {
                this.$floatingAlert.error({
                    title: 'Oops!',
                    message: e.message || 'Houve um problema no momento de limpar o cache. Tente novamente mais tarde',
                })
            }

            this.clearingCache = false
        },
        async submitInterfaceNetCredentials(backendCredentials) {
            this.loadingInterfacenetCredentials = true

            try {
                await subscriberService.updateBackendCredentials(backendCredentials.normalize())
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.loadingInterfacenetCredentials = false
        },
        interfacenetActivationHandler(info) {
            this.backendCredentials.isActive = info
        },
        async retrieveAllInterfacenetListsBasedOnClientIdAndClientSecret(backendCredentials) {
            this.loadingInterfacenetCredentials = true

            try {
                    const reqOptions = {
                        clientId: backendCredentials.clientId,
                        clientSecret: backendCredentials.clientSecret,
                        empresa: '',
                        clientName: '',
                    };

                    const {clientName} = await subscriberService.getInterfacenetClientName(reqOptions)
                    backendCredentials.clientName = clientName;
                    reqOptions.clientName = clientName;

                    this.interfacenetStoreListOptions = await subscriberService.getInterfacenetStoreList(reqOptions);
                    
                    if (this.interfacenetStoreListOptions.length === 1) {
                        backendCredentials.redeStock = this.interfacenetStoreListOptions[0];
                        reqOptions.empresa = backendCredentials.redeStock.key

                        ;[
                            this.interfacenetBranchListOptions,
                            this.interfacenetPriceTableListOptions,
                        ] = await Promise.all([
                            subscriberService.getInterfacenetBranchList(reqOptions),
                            subscriberService.getInterfacenetPriceTableList(reqOptions),
                        ])
                    }

                    this.hasErrorInterfacenetCredentials = false;
            } catch (err) {
                this.hasErrorInterfacenetCredentials = true;

                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.loadingInterfacenetCredentials = false
        },  
        async retrieveAllInterfacenetListsBasedOnAllInfo(redeStock) {
            this.loadingInterfacenetCredentials = true

            try {
                    const reqOptions = {
                        clientId: this.backendCredentials.clientId,
                        clientSecret: this.backendCredentials.clientSecret,
                        empresa: redeStock.key,
                        clientName: this.backendCredentials.clientName,
                    };

                    ;[
                        this.interfacenetBranchListOptions,
                        this.interfacenetPriceTableListOptions,
                    ] = await Promise.all([
                        subscriberService.getInterfacenetBranchList(reqOptions),
                        subscriberService.getInterfacenetPriceTableList(reqOptions),
                    ])

                    this.hasErrorInterfacenetCredentials = false;
            } catch (err) {
                this.hasErrorInterfacenetCredentials = true;

                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.loadingInterfacenetCredentials = false
        },  
        goToMemberManagement() {
            this.$router.push(`/configuracoes/membros`)
        },
    },
    async mounted() {
        this.loadingCredentials = true

        try {
            this.hasErrorInterfacenetCredentials = false;
            const backendCredentials = await subscriberService.getBackendCredentials()
            this.backendCredentials = SubscriberBackendCredentialsFactory.build(backendCredentials, this.subscriber)

            if (this.subscriber.isBackendInterfacenet()) {
                const paginationOptions = {page: 1, limit: 1};
                const filterInterface = {toPartialQueryString: () => ''};
                const productListWrapper = await ProductService.getProducts(paginationOptions, filterInterface)

                if (productListWrapper.result.length) {
                    this.alreadyHasProducts = true;
                }

                if (this.backendCredentials.hasAllBasicInfo()) {
                    const reqOptions = {
                        clientId: this.backendCredentials.clientId,
                        clientSecret: this.backendCredentials.clientSecret,
                        clientName: this.backendCredentials.clientName,
                        empresa: this.backendCredentials.redeStock,
                    };

                    ;[
                        this.interfacenetStoreListOptions,
                        this.interfacenetBranchListOptions,
                        this.interfacenetPriceTableListOptions,
                    ] = await Promise.all([
                        subscriberService.getInterfacenetStoreList(reqOptions),
                        subscriberService.getInterfacenetBranchList(reqOptions),
                        subscriberService.getInterfacenetPriceTableList(reqOptions),
                    ])

                    this.backendCredentials.setRedeStock(this.interfacenetStoreListOptions)
                    this.backendCredentials.setFilialSales(this.interfacenetBranchListOptions)
                    this.backendCredentials.setFilialStock(this.interfacenetBranchListOptions)
                    this.backendCredentials.setPriceTable(this.interfacenetPriceTableListOptions)
                }
            }

        } catch(err) {
            this.hasErrorInterfacenetCredentials = true;

            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loadingCredentials = false
    },
    computed: {
        ...mapState({
            userAuthenticated: state => state.userAuthenticated,
            subscriber: state => state.subscriber,
        }),
    },
}
</script>

<style lang="scss" scoped>
.muven-card {
    textarea {
        resize: none;
    }
}
</style>